import { lazy } from 'react';
export default class BBMPythonDescriptor  {

static getDescription() {
    return {
      name: 'BBPython',
      component: lazy(() =>  import('./BBPython')),
      label: 'BB Python in the browser (experimental)',
      type:"experimental",
      variables: [
       

        {
          name: 'pythoncode deprecated. will be deleted soon',
          type: 'text',
          label: 'python code to execute between {}'
        },
        {
          name: 'pythoncode2',
          type: 'json',
          label: 'python code to execute between 2 {}'
        },
       
        
      ],
    }
  }
}
